import { render, staticRenderFns } from "./u-tab-inline.vue?vue&type=template&id=81c83e8c&scoped=true&"
import script from "./u-tab-inline.vue?vue&type=script&lang=js&"
export * from "./u-tab-inline.vue?vue&type=script&lang=js&"
import style0 from "./u-tab-inline.vue?vue&type=style&index=0&id=81c83e8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c83e8c",
  null
  
)

export default component.exports